import { render, staticRenderFns } from "./Literature.vue?vue&type=template&id=5c6703a6&scoped=true&"
import script from "./Literature.vue?vue&type=script&lang=js&"
export * from "./Literature.vue?vue&type=script&lang=js&"
import style0 from "./Literature.vue?vue&type=style&index=0&id=5c6703a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6703a6",
  null
  
)

export default component.exports